import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { TrendingUp } from "lucide-react";

const MODE_LABEL = { communities: "Communities", asking: "Asking for it", resellers: "Could stock it" };
const Stat = ({ k, v, testid }) => <div className="rounded-lg border border-[#27272A] bg-[#0A0A0A] p-3"><div className="text-[10px] uppercase tracking-wider text-neutral-500">{k}</div><div className="text-xl font-black font-mono text-white mt-1" data-testid={testid}>{v}</div></div>;

/** What happened after the seller contacted leads — so they learn which groups convert. */
export function LeadResults({ refreshKey }) {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/buyer-finder/results").then((r) => setD(r.data)).catch(() => setD(null)); }, [refreshKey]);
  if (!d || !d.totals.contacted) return null;
  const t = d.totals;
  const Group = ({ title, rows, label }) => (
    <div className="rounded-lg border border-[#27272A] bg-[#0A0A0A] p-3">
      <div className="text-[10px] uppercase tracking-wider text-neutral-500 mb-2">{title}</div>
      {rows.map((g) => (
        <div key={g.key} className="flex items-center gap-2 py-1 text-xs" data-testid={`bf-results-${title.toLowerCase().replace(/\s/g, "-")}-${g.key}`}>
          <span className="flex-1 text-neutral-200">{label(g.key)}</span>
          <span className="font-mono text-neutral-500">{g.contacted} sent</span>
          <span className="font-mono text-neutral-300">{g.visited} visited</span>
          <span className="font-mono text-[#FFD60A]">{g.enquiries} enq</span>
          <span className="font-mono text-[#34C759]">{g.purchases} bought</span>
          <span className="w-12 text-right font-mono text-neutral-500">{g.contacted ? Math.round((g.visited / g.contacted) * 100) : 0}%</span>
        </div>
      ))}
    </div>
  );
  return (
    <div className="mt-8" data-testid="bf-results">
      <h2 className="font-bold text-base text-white flex items-center gap-2"><TrendingUp className="h-4 w-4 text-[#34C759]" /> What your outreach did</h2>
      <p className="text-xs text-neutral-500 mt-1">Every message carries a tracked link. We count who clicked, enquired or bought — so you can see which kinds of places convert for your products.</p>
      <div className="mt-3 grid grid-cols-2 sm:grid-cols-5 gap-3">
        <Stat k="Contacted" v={t.contacted} testid="bf-res-contacted" /><Stat k="Visited" v={t.visited} testid="bf-res-visited" /><Stat k="Enquiries" v={t.enquiries} testid="bf-res-enquiries" /><Stat k="Purchases" v={t.purchases} testid="bf-res-purchases" /><Stat k="Revenue" v={`$${t.revenue_usd}`} testid="bf-res-revenue" />
      </div>
      <div className="mt-3 grid md:grid-cols-2 gap-3">
        <Group title="By lead type" rows={d.by_mode} label={(k) => MODE_LABEL[k] || k} />
        <Group title="By source" rows={d.by_source} label={(k) => k} />
      </div>
    </div>
  );
}
